// extracted by mini-css-extract-plugin
export default {"form_container":"Login_form_container__nrkQs","form":"Login_form__HoQ6M"};